/* eslint-disable no-template-curly-in-string */

import React from 'react';
import { Field } from 'redux-form';

import CodeMirrorInput from '../../../../Common/Utils/CodeMirrorInput';

type Props = {
  baseName: string
};

const HtmlContentSettings = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name={`${props.baseName}.text_content`} component={CodeMirrorInput} label="HTML Content" mode="javascript" /><br />
    <span>
      Macros: {"${COOKIES_ENABLED}"} {"${COUNTRY}"} {"${PAGE_DOMAIN}"} {"${USER_IP}"} {"${USER_AGENT_BROWSER}"} {"${USER_AGENT_OS}"} {"${USER_AGENT_DEVICE}"} {"${REQUEST_ID}"} {"${CACHEBUSTER}"}
    </span>
  </div>
);

export default HtmlContentSettings;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/HtmlContentSettings.tsx